export const CURRENCY = {
  AUD: 'AUD', // Australian Dollar
  BRL: 'BRL', // Brazilian real\
  CAD: 'CAD', // Canadian dollar
  CZK: 'CZK', // Czech koruna
  DKK: 'DKK', // Danish krone
  EUR: 'EUR', // Euro
  HKD: 'HKD', // Hong Kong dollar
  HUF: 'HUF', // Hungarian forint
  ILS: 'ILS', // Israeli new shekel
  JPY: 'JPY', // Japanese yen
  MYR: 'MYR', // Malaysian ringgit
  MXN: 'MXN', // Mexican peso
  TWD: 'TWD', // New Taiwan dollar
  NZD: 'NZD', // New Zealand dollar
  NOK: 'NOK', // Norwegian krone
  PHP: 'PHP', // Philippine peso
  PLN: 'PLN', // Polish złoty
  GBP: 'GBP', // Pound sterling
  RUB: 'RUB', // Russian ruble
  SGD: 'SGD', // Singapore dollar
  SEK: 'SEK', // Swedish krona
  CHF: 'CHF', // Swiss franc
  THB: 'THB', // Thai baht
  USD: 'USD', // United States dollar
};

export const CURRENCY_SYMBOL = {
  AUD: '$',
  BRL: 'R$',
  CAD: '$',
  CZK: 'Kč',
  DKK: 'kr',
  EUR: '€',
  HKD: '$',
  HUF: 'Ft',
  ILS: '₪',
  JPY: '¥',
  MYR: 'RM',
  MXN: '$',
  TWD: 'NT$',
  NZD: '$',
  NOK: 'kr',
  PHP: '₱',
  PLN: 'zł',
  GBP: '£',
  RUB: '₽',
  SGD: '$',
  SEK: 'kr',
  CHF: 'CHF',
  THB: '฿',
  USD: '$',
};

export default {CURRENCY, CURRENCY_SYMBOL};
